import { combineReducers } from 'redux';
import httpsReducer from "./httpsReducer";
import settingsReducer from "./settingsReducer";
import validateAgentReducer from "./validateAgentReducer";

export default combineReducers({
    https: httpsReducer,
    settings: settingsReducer,
    validateAgent: validateAgentReducer
})
